var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[_c('help-content',{attrs:{"title":'ベルトを交換したい'}},[_c('template',{slot:"content"},[_c('div',{staticClass:"text"},[_vm._v("\n        交換用ベルトは"),_c('a',{staticClass:"help-detail-link",attrs:{"href":"https://h5.werunclub.net/user-bean/index.html#/bean/gifts/23"}},[_vm._v("ホーム＞マイルを使う")]),_vm._v("にてお買い求めいただけます。\n      ")])])],2)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40863d40","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Help35.vue
// module id = YNXj
// module chunks = 0